import { Component } from '@angular/core';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CtaComponent } from '../../shared/components/cta/cta.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'wci-no-page-found',
    imports: [ButtonComponent, CtaComponent, RouterLink],
    templateUrl: './no-page-found.component.html',
    styles: ``,
})
export class NoPageFoundComponent {}
